module.exports = __webpack_public_path__ + "img/shipping_type_2.91f084a.webp";